const MozambiqueSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111950)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.8101 27.8271L5.8584 34.1425C9.47746 37.7621 14.4769 40.0011 19.9999 40.0011C28.2679 40.0011 35.3627 34.9832 38.4086 27.8271H10.8101Z"
        fill="#FFDA44"
      />
      <path
        d="M38.4396 12.2463C35.4108 5.05172 28.2958 0 19.9999 0C14.4769 0 9.47746 2.23898 5.8584 5.85852L10.867 12.2463H38.4396Z"
        fill="#496E2D"
      />
      <path
        d="M4.34766 14.7109V25.2181H39.3109C39.7595 23.5548 39.9998 21.806 39.9998 20.0008C39.9998 18.1694 39.7531 16.3959 39.292 14.7109H4.34766Z"
        fill="black"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#A2001D"
      />
      <path
        d="M8.09426 14.7832L9.38918 18.7688H13.5803L10.1898 21.2323L11.4846 25.218L8.09426 22.7547L4.70371 25.218L5.99887 21.2323L2.6084 18.7688H6.79918L8.09426 14.7832Z"
        fill="#FFDA44"
      />
      <path d="M4.30469 20H11.8847V23.4783H4.30469V20Z" fill="#F0F0F0" />
      <path
        d="M13.3205 16.013L12.0908 14.7832L8.09484 18.7791L4.09891 14.7832L2.86914 16.013L6.86859 20.0054L2.86914 24.0049L4.09891 25.218L8.09484 21.2293L12.0908 25.218L13.3205 24.0049L9.32109 20.0054L13.3205 16.013Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111950">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MozambiqueSvg;
